import React, {FC, ReactNode, useEffect, useRef} from "react"
import {DisableFormElementsContext} from "../context/disableFormElementsContext"

interface DisableFieldsComponentProps {
    disabled?: boolean
    className?: string
    children?: ReactNode
}

export const DisableFormElementsComponent: FC<DisableFieldsComponentProps> = ({
    children,
    disabled,
    className,
}) => {
    const modalFieldsetRef = useRef<HTMLFieldSetElement>(null)

    useEffect(() => {
        if (modalFieldsetRef.current) {
            modalFieldsetRef.current.disabled = disabled || false
        }
    }, [disabled])
    return (
        <DisableFormElementsContext.Provider value={!!disabled}>
            <fieldset
                className={className}
                id={"disableFormElementsComponent"}
                ref={modalFieldsetRef}
            >
                {children}
            </fieldset>
        </DisableFormElementsContext.Provider>
    )
}
